import React from 'react';
import UnderwritingSingleTenant from '../UnderwritingSingleTenant';
import UnderwritingMultiTenant from '../UnderwritingMultiTenant';
import {
    formatPhoneNumber,
    formatProposalAgentDisplayName,
    formatProposalListingEmail,
} from "../../utils";
import request from "arcdynamic-request";
import {AGENTS} from '../../consts/tables';
import Alert from "../Alert";

const cloneDeep = require('lodash.clonedeep');

export default class Financials extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            newData: props.data,
            agents: [],
            agentIsCurrentUser: false,
            error: null,
            success: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.close = this.close.bind(this);
        this.setDataFromChild = this.setDataFromChild.bind(this);
        document.body.overflow = 'hidden';
    }


    static equals(agents, agentIds) {
        return agents.length === agentIds.length && agents.map((value, index) => value.id === agentIds[index]);
    }

    async componentDidMount() {
        const agents = this.state.agents;
        const teamAgentsIds = [this.props.data.LISTING_AGENT_1, this.props.data.LISTING_AGENT_2, this.props.data.LISTING_AGENT_3]
            .filter(id => id !== null && id !== undefined);
        const agentId = this.props.data.LISTING_AGENT_4;

        if (!agents.length) {
            const agentsIds = agentId ? [agentId] : teamAgentsIds;
            const tableName = agentId ? AGENTS : 'TEAM';
            let agentIsCurrentUser = false;

            if (agentsIds && agentsIds.length && !Financials.equals(agents, agentsIds)) {
                await Promise.all(agentsIds.map(async id => {
                    const agentData = await this.getAgent(id, tableName);
                    if (agentData) {
                        const agent = {
                            id: id,
                            name: formatProposalAgentDisplayName(agentData.FIRST_NAME, agentData.LAST_NAME),
                            phone: formatPhoneNumber(agentData.PHONE),
                            email: formatProposalListingEmail(
                                agentData.EMAIL || '',
                                agentData.FIRST_NAME,
                                agentData.LAST_NAME
                            ),
                        };
                        agents.push(agent);

                        if (tableName === 'TEAM' && String(agentData.EMAIL || '').toLowerCase() === String(this.props.email || '').toLowerCase()) {
                            agentIsCurrentUser = true;
                        }
                    }
                }));

                this.setState({agents, agentIsCurrentUser});
            }
        }
    }

    async getAgent(id, tableName) {
        const res = await request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', tableName, {
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            }]
        });
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            return res.data[0];
        }
    }

    handleChange(e) {
        this.setData(e.currentTarget.name, e.currentTarget.value);
    }

    setData(key, value) {
        const data = {...cloneDeep(this.state.data), [key]: value};
        this.setState({data});
    }

    close() {
        this.props.close(true);
    }

    formatFinancialsError(error) {
        const message = error && typeof error === 'string' ? error : (error && error.message) || 'Unidentified Error';
        if (/SQLSTATE\[22007\].*Incorrect date value/i.test(message) || /Invalid datetime format/i.test(message)) {
            return 'Could not save: one or more date fields has an invalid value. Use MM/DD/YYYY, or MTM for month-to-month lease end dates.';
        }
        // Prefer a short readable message over dumping full SQL.
        if (/SQLSTATE\[/i.test(message) && message.length > 280) {
            const short = message.split('(Connection:')[0].trim();
            return short.length > 20 ? short : 'Could not save financials. Please try again or contact support.';
        }
        return message;
    }

    setDataFromChild({error = false, newData, savedTenants, newTenants, success}) {
        if (error) {
            this.setState({error: this.formatFinancialsError(error)}, () => {
                setTimeout(() => {
                    this.setState({error: null});
                }, 3000)
            });
            return;
        }
        const state = {
            success,
        };
        if (newData)
            state.newData = newData;
        this.setState(state, () => {
            setTimeout(() => {
                this.setState({success: null});
            }, 3000)
        });
        this.props.parentSetData({newData, savedTenants, newTenants});
    }
    
    componentWillUnmount() {
        document.body.overflow = 'auto';
    }

    render() {
        const data = this.state.newData;
        const {agents, agentIsCurrentUser, error, success, } = this.state;
        const proposalData = this.props.propsalData;
        const historySnapshot = this.props.historySnapshot || null;
        const readOnlySnapshot = !!this.props.readOnlySnapshot;

        return (
            <div className='Financials' lang='en-US' id="visible-print">
                {['STNL', 'Other'].includes(data.TYPE) ?
                    <UnderwritingSingleTenant proposalData={proposalData} loation={this.props.location} data={data} parentSetData={this.setDataFromChild} agents={agents} agentIsCurrentUser={agentIsCurrentUser} historySnapshot={historySnapshot} readOnlySnapshot={readOnlySnapshot}/>
                    :
                    <UnderwritingMultiTenant proposalData={proposalData} data={data} allTenantsById={this.props.allTenantsById} parentSetData={this.setDataFromChild} agents={agents} agentIsCurrentUser={agentIsCurrentUser} historySnapshot={historySnapshot} readOnlySnapshot={readOnlySnapshot}/>
                }
                {success ? <Alert type='success'>{success}</Alert> : null}
                {error ? <Alert type='error'>{error}</Alert> : null}
                <div className="close-button" onClick={this.close}/>
                <img src={arc.path.media+'stnl-background.png'} style={{visibility: 'hidden', position: 'absolute', width: 0, height: 0}}/>
            </div>
        );
    }
}